import React from 'react';
import PropTypes from 'prop-types';
import DropDown from '../DropDown/DropDown'
import classnames from 'classnames';
import css from './styles.less';

class RoomsDropDown extends React.Component {

    specialLabel = (roomNumber) => {
        const { pax, titles } = this.props;
        const roomStr = titles.Room || 'Room';
        const ofStr = titles.Of || 'Of';
        return `${roomStr} ${roomNumber} ${ofStr} ${pax.length}`;
    }

    render() {
            const {
                pax,
                direction,
                activeRoomNum,
                changeActiveRoomNumber,
                onClickRemoveRoom,
                onClickAddRoom
            } = this.props;
            
        return (
            <div className={classnames(css.rooms)}>
                <div >
                    <DropDown 
                        direction={direction}
                        specialLabel={this.specialLabel}
                        list={pax}
                        labelName='roomNum'
                        valueName='roomNum'
                        selectedValue={activeRoomNum}
                        actions={pax.length > 1 ? [{ name: 'minus', action: onClickRemoveRoom }] : []}
                        onChange={changeActiveRoomNumber}
                        lastItemAction={{ name: 'plus', action: onClickAddRoom }}
                    />
                </div>
                <div className={classnames(css.oneRoom, 'hidden')}>
                    <span className={css.roomLabel}>
                        {this.specialLabel(activeRoomNum)}
                    </span>
                    <span className={`glyphicon glyphicon-plus ${css.addRoom}`} onClick={onClickAddRoom}></span>
                </div>
            </div>
        );
    }
};

RoomsDropDown.propTypes = {
    pax: PropTypes.array,
    isRounded: PropTypes.bool,
    onChangePax: PropTypes.func,
    onClickRemoveRoom: PropTypes.func,
    onClickAddRoom: PropTypes.func,
    changeActiveRoomNumber: PropTypes.func,
    activeRoomNum: PropTypes.number,
    titles: PropTypes.object
}

export default RoomsDropDown;




// WEBPACK FOOTER //
// ./src/components/PaxPart/RoomsDropDown.js